import { render } from "./AppMast.vue?vue&type=template&id=e99dd14c&scoped=true&ts=true"
import script from "./AppMast.vue?vue&type=script&lang=ts"
export * from "./AppMast.vue?vue&type=script&lang=ts"

import "./AppMast.vue?vue&type=style&index=0&id=e99dd14c&scoped=true&lang=scss"

import exportComponent from "/Users/james/Desktop/VueJS/ingredient-swap/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e99dd14c"]])

export default __exports__